import { render } from "./CourseListHorizontal.vue?vue&type=template&id=235693da&scoped=true"
import script from "./CourseListHorizontal.vue?vue&type=script&lang=js"
export * from "./CourseListHorizontal.vue?vue&type=script&lang=js"

import "./CourseListHorizontal.vue?vue&type=style&index=0&id=235693da&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235693da"]])

export default __exports__